import Web3TxSettingsModal from "@/components/Web3/TxSettings/Dialog";
import { SupButton } from "@repo/core-ui";
import { SupCog } from "@repo/core-ui";
import React, { Fragment, useState } from "react";

export default function Web3CommonRefundAddress() {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <Fragment>
      <SupButton fluid prefixIcon={<SupCog className="h-6 w-6" />} onClick={() => setOpen(true)} disabled={open}>
        Set refund address
      </SupButton>
      <Web3TxSettingsModal open={open} setOpen={setOpen} defaultTab="refunds" />
    </Fragment>
  );
}
